// extracted by mini-css-extract-plugin
export var animationContainer = "_ct-0";
export var asteriskIcon = "_ct-8";
export var conversationLeftSection = "_ct-4";
export var conversationListItem = "_ct-3";
export var conversationMiddleSection = "_ct-5";
export var conversationRightSection = "_ct-6";
export var detailsContent = "_ct-1";
export var listContainer = "_ct-7";
export var modalContent = "_ct-2";